<template>
  <el-col :lg="12">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-button @click="maximize = !maximize" type="text">{{
          $t("faturas")
        }}</el-button>
      </div>
      <el-table :data="tableDataList" style="width: 100%">
        <el-table-column type="selection" width="60"></el-table-column>
        <el-table-column sortable prop="customer" :label="$t('cliente')">
          <template slot-scope="scope">
            {{ scope.row.customer.companyname }}
          </template>
        </el-table-column>
        <el-table-column prop="value" :label="$t('valor')">
          <template slot-scope="scope">
            {{
              scope.row.value
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="services" :label="$t('valor-servico')">
          <template slot-scope="scope">
            {{
              scope.row.services
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="price" :label="$t('valor-tabela')">
          <template slot-scope="scope">
            {{
              scope.row.price
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="discount" :label="$t('desconto')">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.discount"
              @change="calc(scope.$index)"
              :precision="2"
              :step="0.1"
              :max="100"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="total" :label="$t('valor-total')">
          <template slot-scope="scope">
            {{
              scope.row.total
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          width="110"
          :label="$t('data')"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.createdAt | formatDate }}
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom clearfix">
        <el-row :gutter="5">
          <el-col :lg="8">
            <el-pagination
              layout="prev, pager, next"
              :total="1"
            ></el-pagination>
          </el-col>
          <el-col :lg="8" style="margin-top: 2px; float: right">
            <el-dropdown>
              <el-button>
                Exportar
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <download-excel :data="tableData"> XLS </download-excel>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </el-col>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import { InvoiceServices } from "@/services/customers/invoice.services";

export default {
  name: "InvoiceList",
  props: {
    range: Array,
    customer: String,
    service: String,
  },
  computed: {
    tableDataList() {
      const vm = this;
      return vm.tableData.filter(
        (x) =>
          (vm.service && x.services.id == vm.service) ||
          (vm.customer && x.customers.id == vm.customer) ||
          (vm.range &&
            new Date(x.createdAt).getTime() >=
              new Date(vm.range[0]).getTime() &&
            new Date(x.createdAt).getTime() <= new Date(vm.range[1]).getTime())
      );
    },
  },
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      down: false,
      filter: "",
      user: {
        type: "1",
      },
    };
  },
  methods: {
    send() {
      var vm = this;
      vm.$router.push("/servicos/prepostagem").catch(() => {});
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      InvoiceServices.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.fetchRecords();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
